export default __webpack_public_path__ + "static/media/g.93f8b813.svg";